import React from 'react';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';

const ZonnePanelenInfo = (props) => {

		const latLng = (props.latLng.length > 1) ? props.latLng.split(',') : false;

		return (!!latLng && <div>
				<iframe
						src={`https://mapbuilder.spotzi.com/nl?share_id=e1b8caba-38ef-4506-a0bd-cedc1aca6396&x=${latLng[1]}&y=${latLng[0]}&z=20`}
						width="100%" height="600px"></iframe>
			{ props.page_content && <div dangerouslySetInnerHTML={{__html: props.page_content.page_content}} />}</div>
		)

}


export default HeaderFooterHOC(ZonnePanelenInfo, 'zonnepanelen');


